import * as Sentry from '@sentry/react';

import { isDev } from '~/dev/utils/isDev';

export const captureException = (
  message: string,
  error: any,
  tags: Record<string, string>,
) => {
  if (!isDev) {
    Sentry.captureException(error, {
      tags: tags,
      extra: { message },
    });
  }
};

export const captureMessage = (
  message: string,
  tags: Record<string, string>,
) => {
  if (!isDev) {
    Sentry.captureMessage(message, { tags });
  }
};

/** Coerces an arbitrary details object into Sentry's string-only tag shape. */
export const toSentryTags = (
  details: Record<string, unknown>,
): Record<string, string> =>
  Object.fromEntries(
    Object.entries(details).map(([key, value]) => [key, String(value)]),
  );
